import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import classNames from 'classnames';

import GiphyStore from 'stores/GiphyStore';
import ProfileStore from 'stores/ProfileStore';

import GiphyWrapper from '../GiphyWrapper/GiphyWrapper';

import styles from './GiphyDesktop.css';


const GiphyDesktop = (props) => {
  const { isGifsWrapperVisible, anchorElForGif, closePopper } = GiphyStore;
  const { isDesktop, handleSendButton } = props;
  const { inTheatreMode } = ProfileStore;

  return (
    <ClickAwayListener onClickAway={closePopper}>
      <Popper
        anchorEl={anchorElForGif}
        className={classNames({
          [styles.desktopPopper]: true,
          [styles.desktopPopperTheatre]: inTheatreMode,
        })}
        disablePortal={inTheatreMode}
        id="giphyPopper"
        modifiers={{ flip: { enabled: false } }}
        open={isGifsWrapperVisible}
        placement="top"
      >
        <GiphyWrapper handleSendButton={handleSendButton} isDesktop={isDesktop} />
      </Popper>
    </ClickAwayListener>
  );
};

GiphyDesktop.propTypes = {
  handleSendButton: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
};

export default observer(GiphyDesktop);
